(function ($) {
	$(document).ready(function() {
		init();
		ajaxHistory();
      	termsConditions();
      	clickListeners();
	});

	function init() {
		$('.nano').nanoScroller({ iOSNativeScrolling: true });
		$(".content").css("padding-top", $(".unveiled-navigation").outerHeight());

		$("#ContentWrap").on('load', '#Content', function(e) {
			$body.removeClass('loading');
		});

		ajaxCart();
      	$(".mobile-nav").css("margin-top", $("#breadcrumb").outerHeight() ? $("#breadcrumb").outerHeight() + "px" : "0px");

		//do index initialization
		if($("body").hasClass('template-index')) {
			initSVGs();
		}
	}

	function initSVGs() {
		$("#FeaturedBanner1").load("//cdn.shopify.com/s/files/1/0871/3170/t/7/assets/featured-banner1.svg?v=179408821955384011091442869827");
		$("#FeaturedBanner2").load("//cdn.shopify.com/s/files/1/0871/3170/t/7/assets/featured-banner2.svg?v=133797537061029396161442869827");
		$("#FeaturedBanner3").load("//cdn.shopify.com/s/files/1/0871/3170/t/7/assets/featured-banner3.svg?v=140168942318362451931442869827");
	}

	var clickListeners = function() {
        var $mobileNav = $(".mobile-nav");
        
		$('.dropdown-button').click(function(e) {
			if ( !$(this).hasClass('dropdown-open') ) {
				e.preventDefault();
				$('.dropdown-open').removeClass('dropdown-open');

				$(this).addClass('dropdown-open');
				$(this).next(".dropdown-list").addClass('dropdown-open');
			} else if ( $(this).hasClass('dropdown-open') ) {
				var $this = $(this),
				url = $this.attr('href'),
				title = $this.attr('title')||null;

				if ( event.which == 2 || event.metaKey ) { return true; }
					
				// Ajaxify this link
				History.pushState(null,title,url);
				e.preventDefault();
				return false;
			}
		});
          
        $(".menu--left-open").click(function(e) {
          if( $('.menu--left').hasClass('menu-open') ) {
              $mobileNav.css("margin-top", $("#breadcrumb").outerHeight() ? $("#breadcrumb").outerHeight() + "px" : "0px");
              $('.menu--left').removeClass('menu-open');
              $('body').removeClass('menu-open');
          } else if ( $('.menu--right').hasClass('menu-open') ) {
              $('.menu--right').removeClass('menu-open');
              $('.menu--left').addClass('menu-open');
          } else {
              $mobileNav.css("margin-top", "0px");
              $('.menu--left').addClass('menu-open');
              $('body').addClass('menu-open');
          }
          e.preventDefault();
        });
        $(".menu--right-open").click(function(e) {
          if( $('.menu--right').hasClass('menu-open') ) {
              $mobileNav.css("margin-top", $("#breadcrumb").outerHeight() ? $("#breadcrumb").outerHeight() + "px" : "0px");
              $('.menu--right').removeClass('menu-open');
              $('body').removeClass('menu-open');
          } else if ( $('.menu--left').hasClass('menu-open') ) {
          	  $('.menu--left').removeClass('menu-open');
              $('.menu--right').addClass('menu-open');
          } else {
              $mobileNav.css("margin-top", "0px");
              $('.menu--right').addClass('menu-open');
              $('body').addClass('menu-open');
          }
          e.preventDefault();
     	 });
	}

	var ajaxHistory = function() {
		var History  = window.History,
			document = window.document,
			rootUrl  = History.getRootUrl(),
			scroll   = true,
			removeFromCart = false;

		if ( !History.enabled ) {
			console.log("History is not enabled");
			return false;
		}

		var $body = $("body"),
			$window = $(window);

		$.expr[':'].internal = function(obj, index, meta, stack){
			// Prepare
			var	$this = $(obj),
				url = $this.attr('href')||'',
				isInternalLink;
			
			// Check link
			isInternalLink = url.substring(0,rootUrl.length) === rootUrl || url.indexOf(':') === -1;
			
			// Ignore or Keep
			return isInternalLink;
		};

		$.fn.ajaxify = function(){
				// Prepare
				var $this = $(this);
				
				// Ajaxify
				$this.find('a:internal').not(".no-ajaxy").click(function(event){
					// Prepare
					var
						$this = $(this),
						url = $this.attr('href'),
						title = $this.attr('title')||null;
					
					// Continue as normal for cmd clicks etc
					if ( event.which == 2 || event.metaKey ) { return true; }

					if ($this.hasClass("no-scroll")) {
						scroll = false;
					}
					if ($this.hasClass("cart-remove")) {
						removeFromCart = true;
					}
					
					// Ajaxify this link
					History.pushState(null,title,url);
					event.preventDefault();
					return false;
				});
				
				// Chain
				return $this;
		};

		$body.ajaxify();

		$window.bind('statechange', function(){
			var State = History.getState(),
				url = State.url,
				relativeUrl = url.replace(rootUrl,'');

			// Set Loading
			$body.addClass('loading');

			$.ajax({
				url: url,

				success: function(data, textStatus, jqXHR) {
					var $data = $( data ),
						$content = $data.find("#Content"),
                        $breadcrumb = $data.find("#breadcrumb"),
						$template = $content.attr('data-template');

					var $live = $('<div>').html(data);

					var imgCount = $live.find('img').length;
					$('img',$live).load(function(){
						imgCount--;
						if (imgCount==0)
						{
							$body.removeClass('loading');
						}
					});

					$live = null;
				
					$("#Content").replaceWith($content);
					$("title").replaceWith($content.find("title"));
                  	$(".unveiled-navigation").remove();
                    $("body").append($breadcrumb);

					if($template == "template-collection") {
						var $collection_tags = $data.find('.collection-tags');
						if ($collection_tags) {
							$(".collection-tags").replaceWith($collection_tags);
						} else {
							$(".collection-tags").html("");
						}
					} else {
						$(".collection-tags").html("");
					}
					
					$body.attr("class", function(i, c){
						return c.replace(/(^|\s)template-\S+/g, '');
					});

					$body.addClass($template);

					if ( typeof window._gaq !== 'undefined' ) {
						window._gaq.push(['_trackPageview', relativeUrl]);
					}

					if(scroll) {
						$("#ContentWrap").scrollTop(0);
					}
					scroll = true;
				},
				complete: function(jqXHR, textStatus) {
					$body.ajaxify();
					$(".menu-open").each(function(index, el) {
						$(el).removeClass('menu-open');
					});
					init();
                  	termsConditions();
					if (removeFromCart) {
						updateCart(true);
						removeFromCart = false;
					}
				},
				error: function(jqXHR, textStatus, errorThrown) {
					console.log("Ajax error: " + errorThrown);
					console.log("Ajax status: " + textStatus);
					document.location.href = url;
					return false;
				}
			});
		});
	}

	var ajaxCart = function() {
		$("form[action='/cart/add']").submit(function(e){
			e.preventDefault();
			var $addToCartForm = $(this);

			$.ajax({
				url: "/cart/add.js",
				dataType: 'json',
				type: 'post',
				data: $addToCartForm.serialize(),
				success: function(data) {
                  	$('.menu--right').addClass('menu-open');
					$(".cart img").on('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
						setTimeout(function(){
							$('.menu--right').removeClass('menu-open');
						}, 1000);
					});
                  
					$(".cart img").addClass('animated wobble');
					$("#cart-count").html("<span>Added to Cart!</span>");
					updateCart(false);
				}
			});

			return false;
		});
	}
	var updateCart = function(removed) {
		$.ajax({
			url: "/cart",
			dataType: "html",
			type: 'get',
			success: function(data) {
				var $html = $(data);
				$cartCount = $html.find("#cart-count");
				if(removed) {
					$(".cart img").removeClass('animated wobble');
                  	$('.menu--right').addClass('menu-open');
					$(".cart img").addClass('animated wobble');
					$("#cart-count").html("<span>Removed from Cart!</span>");
				}
				setTimeout(function(){
					$(".cart img").removeClass('animated wobble');
					$("#cart-count").replaceWith($cartCount);
                  	$('.menu--right').removeClass('menu-open');
				}, 1400); 
			}
		});
	}
})(jQuery);
  
function termsConditions(){
  $('#checkout').click(function(e) {
    if($('#terms').prop('checked') == false){
       	e.preventDefault();
       	alert("You must accept the Terms and Conditions before continuing.");
    }else{
      return true;
    }
  });
}